var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20184 10.2488H0.220113V3.87747H2.20184V10.2488ZM1.22197 3.00448C0.909437 3.00448 0.639525 2.89083 0.412231 2.66354C0.184936 2.43624 0.0712891 2.16633 0.0712891 1.8538C0.0712891 1.54127 0.184936 1.27136 0.412231 1.04407C0.639525 0.816772 0.909437 0.703125 1.22197 0.703125C1.5345 0.703125 1.80441 0.816772 2.0317 1.04407C2.259 1.27136 2.37264 1.54127 2.37264 1.8538C2.37264 2.16633 2.259 2.43624 2.0317 2.66354C1.80441 2.89083 1.5345 3.00448 1.22197 3.00448ZM9.61783 10.2502H7.63611V7.13908C7.63611 6.62767 7.59349 6.25831 7.50825 6.03102C7.35199 5.64746 7.04656 5.45568 6.59197 5.45568C6.13738 5.45568 5.81775 5.62615 5.63308 5.96709C5.49102 6.2228 5.41999 6.59926 5.41999 7.09646V10.2502H3.45957V3.87883H5.35606V4.75249H5.37737C5.51943 4.46837 5.74672 4.23397 6.05925 4.0493C6.40019 3.822 6.79796 3.70836 7.25255 3.70836C8.17593 3.70836 8.8223 3.99958 9.19165 4.58202C9.47577 5.05081 9.61783 5.77531 9.61783 6.75552V10.2502Z",
    fill: "#2867B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c2e9a9f57723d959bbc37c54f381ba5c.svg";
export { ForwardRef as ReactComponent };